import { useColorModeValue } from "@chakra-ui/react";
import {
  white,
  whiteDark,
  backgroundLight,
  backgroundLightDark,
  textPrimary,
  textSecondary,
  bgLight,
  bgLightDark,
  newBorder,
  newBorderDark,
  backgroundGrey,
  hoverItemColor,
  primaryAlt,
} from "../utils/colors";

const useThemeColors = () => {
  const colors = {
    whiteMode: useColorModeValue(white, whiteDark),
    backgroundLightMode: useColorModeValue(
      backgroundLight,
      backgroundLightDark
    ),
    textPrimaryMode: useColorModeValue(textPrimary, white), // Example for text
    textSecondaryMode: useColorModeValue(textSecondary, "#BBBBBB"), // Example for text
    bgLightMode: useColorModeValue(bgLight, bgLightDark), // Example for background
    newBorderMode: useColorModeValue(newBorder, newBorderDark), // Example for border
    planBorderSpecialMode: useColorModeValue("#E2E2E2", "#555"), // Example for border
    backgroundGreyMode: useColorModeValue(backgroundGrey, "#333"), // Example for background
    hoverItemColorMode: useColorModeValue(hoverItemColor, "#1c1c27"), // Example for background
    textPrimaryButtonMode: useColorModeValue(textPrimary, primaryAlt), // Example for text
    menuHoverMode: useColorModeValue("#F5F5F5", "#333"), // Example for background
  };
  return colors;
};

export default useThemeColors;
